const header = {
  el: {
    root: document.querySelectorAll<HTMLElement>('.header'),
    officeButton: document.querySelector('.header__office-button'),
    officeDrop: document.querySelector('.header__offices-drop'),
    navButtons: document.querySelectorAll<HTMLButtonElement>('.main-navigation__button'),
  },
  init() {
    if (this.el.root) {
      this.offices()
    }
  },

  offices() {
    if (this.el.officeButton) {
      this.el.officeButton.addEventListener('click', () => {
        if (document.querySelector<HTMLElement>('.header__offices-drop').classList.contains('open')) {
          this.el.officeDrop.classList.remove('open')
          this.el.officeButton.setAttribute('aria-expanded', 'false')
        } else {
          this.el.officeDrop.classList.add('open')
          this.el.officeButton.setAttribute('aria-expanded', 'true')

          if (document.querySelector<HTMLElement>('.main-navigation__drop.open')) {
            document.querySelector('.main-navigation__drop.open').classList.remove('open')
            if (this.el.navButtons) {
              this.el.navButtons.forEach((button) => {
                button.setAttribute('aria-expanded', 'false')
              })
            }
          }
        }
      })
    }
  },
}

export default header
